import axios from "axios";
import {
  LanguageForm,
  AccessTokenAPI,
  BusinessId,
  CompanyId,
  ServiceId,
} from "../../getLocalStorage";

export const getSelfPickupAdmin = async (id) => {
  let config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `${process.env.REACT_APP_API_URL}/api/setting/selfpickup/getSelfPickupAdmin?company_uid=${CompanyId}&business_uid=${BusinessId}&service_code=${ServiceId}&id=${id}&language_code=${LanguageForm}`,
    headers: {
      Authorization: `Bearer ${AccessTokenAPI}`,
    },
  };

  return axios
    .request(config)
    .then((response) => {
      return response.data.data;
    })
    .catch((error) => {
      console.log(error);
    });
};
